import type { FC, RefObject } from 'react'
import { createRef, useState } from 'react'
import { createPopper } from '@popperjs/core'
import cn from 'classnames'
import SvgChevronDown from 'components/icons/ChevronDown'
import SvgChevronUp from 'components/icons/ChevronUp'
import type { DropdownProps } from '.'
import s from './dropdown.module.css'
import { DropdownItem } from './types'

const Dropdown: FC<DropdownProps> = ({
  placeholder = 'Selecione...',
  pre = '',
  selected = null,
  items = null,
  onSelect,
  dropdownClassName,
}) => {
  const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false)
  const btnDropdownRef = createRef()
  const popoverDropdownRef = createRef()

  function openDropdownPopover() {
    // @ts-ignore
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: 'bottom-start',
    })
    setDropdownPopoverShow(true)
  }

  function closeDropdownPopover() {
    setDropdownPopoverShow(false)
  }

  function toggle() {
    if (!dropdownPopoverShow) {
      openDropdownPopover()
    } else {
      closeDropdownPopover()
    }
  }

  if (!items) {
    return <></>
  }

  function handleSelect(value: DropdownItem['value']) {
    onSelect(value)
    closeDropdownPopover()
  }

  function getLabel() {
    const find = items?.find((item) => item.value === selected)
    if (find) {
      return find.label
    }

    return placeholder
  }

  return (
    <div className={s.root}>
      <div className={s.main}>
        <div className={s.content}>
          <button
            className={s.button}
            type="button"
            ref={btnDropdownRef as RefObject<HTMLButtonElement>}
            onClick={toggle}
          >
            <span>{selected ? [pre, getLabel()] : placeholder}</span>
            {dropdownPopoverShow ? <SvgChevronUp /> : <SvgChevronDown />}
          </button>
          <div
            ref={popoverDropdownRef as RefObject<HTMLDivElement>}
            className={cn(s.dropdown, dropdownPopoverShow ? s.open : s.hide, dropdownClassName)}
          >
            {items &&
              items.map(({ value, label, right }) => (
                <button
                  key={`dropdown-${value}`}
                  type="button"
                  className={cn(s.item, value === selected?.value)}
                  onClick={() => handleSelect(value)}
                >
                  <span>{label}</span>
                  {right || <></>}
                </button>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dropdown
